import { Box, Table, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import useIsTimeFormat24H from 'modules/shift_management/hooks/useIsTimeFormat24H'

const TableHeader = () => {
  const weekdays = moment.weekdays(true)
  const { isTimeFormat24H } = useIsTimeFormat24H()
  const cellWidth = isTimeFormat24H ? 's200' : 's240'

  return (
    <Table.Head>
      <Table.Row>
        <Table.HeadCell>
          <Box width="s140">
            <Text.Normal>{i18n.t('shift_management.rotating_shifts.schedules.name')}</Text.Normal>
          </Box>
        </Table.HeadCell>
        {weekdays.map((str) => (
          <Table.HeadCell key={str}>
            <Box width={cellWidth}>
              <Text.Normal>{str}</Text.Normal>
            </Box>
          </Table.HeadCell>
        ))}
      </Table.Row>
    </Table.Head>
  )
}

export default TableHeader
